import { Tabs } from '@mantine/core';
import cs from 'classnames';
import { groupBy } from 'lodash';
import type { FC } from 'react';
import { useMemo } from 'react';
import { IconFlash } from '@/Module/Icon';
import { useAppSelector } from '@/Module/Store/Hook';
import { SubscriptionPlan } from '@/Module/Subscription/Component';
import { WRAP_STYLE } from '@/Module/Subscription/Component/SubscriptionPageContainer/SubscriptionPageTabInner';
import type { ISubscriptionPlan } from '@/Module/Subscription/Model/DataModel';
import type { TColor } from '@/Module/Subscription/Model/Types/TColors';
import { selectedSubscriptionPlanActiveSelector } from '@/Module/Subscription/Store/Selector/selectedSubscriptionPlanActiveSelector';
import styles from './WelcomeSubscriptionTab.module.scss';
interface IGroupGroup {
  duration: number;
  items: ISubscriptionPlan[];
  color?: TColor;
}
interface IValueTab {
  month: string;
  width: string;
  percentage?: string;
}
export const VALUE_TAB: Record<number, IValueTab> = {
  30: {
    month: '1 ماهه',
    width: 'flex-1'
  },
  31: {
    month: '1 ماهه',
    width: 'flex-1'
  },
  93: {
    month: '3 ماهه',
    width: 'flex-2',
    percentage: '٪20 صرفه‌جویی'
  },
  90: {
    month: '3 ماهه',
    width: 'flex-2',
    percentage: '٪20 صرفه‌جویی'
  },
  186: {
    month: '6 ماهه',
    width: 'flex-2',
    percentage: '٪40 صرفه‌جویی'
  },
  275: {
    month: '9 ماهه',
    width: 'flex-3',
    percentage: '٪35 صرفه‌جویی'
  },
  270: {
    month: '9 ماهه',
    width: 'flex-3',
    percentage: '٪35 صرفه‌جویی'
  },
  365: {
    month: 'سالانه',
    width: 'flex-3',
    percentage: '٪40 صرفه‌جویی'
  }
};
const WelcomeSubscriptionTab: FC = () => {
  const person = useAppSelector(state => state.auth.person?.gradeId)!;
  const planList = useAppSelector(state => selectedSubscriptionPlanActiveSelector(state));
  const planListCustom = planList.filter(item => item.metaData?.split('-').includes(person?.toString()));
  const data = useMemo(() => {
    const groupByTypeId: IGroupGroup[] = [];
    Object.entries(groupBy(planListCustom, 'duration')).forEach(([duration, groupList]) => {
      groupByTypeId.push({
        duration: Number(duration),
        items: groupList,
        color: groupList[0].color
      });
    });
    return groupByTypeId;
  }, [planList]);
  return <Tabs aria-label="primary" defaultValue="2" unstyled classNames={{
    root: 'flex flex-col gap-3',
    list: 'flex text-center relative flex-wrap bg-blueOne mt-20 flex-row-reverse  border-2 border-blueThree w-full mx-auto  flex-nowrap rounded-md  '
  }} data-sentry-element="Tabs" data-sentry-component="WelcomeSubscriptionTab" data-sentry-source-file="WelcomeSubscriptionTab.tsx">
      <Tabs.List data-sentry-element="unknown" data-sentry-source-file="WelcomeSubscriptionTab.tsx">
        {data.map((group, index) => <div className={cs('relative', VALUE_TAB[group.duration].width)} key={group.duration}>
            <div className="absolute bottom-[calc(100%+10px)] left-0 ">
              <div className={cs('text-blueFive font-bold pr-[30px] max-w-[120px] text-right', group.duration > 100 && '!text-redFour')}>
                {VALUE_TAB[group.duration].percentage}
              </div>
              {VALUE_TAB[group.duration].percentage && <IconFlash size="small" className="absolute -bottom-2 right-0 z-[-1]" />}
            </div>
            <Tabs.Tab key={VALUE_TAB[group.duration]?.month} value={String(index)} classNames={{
          tab: styles.tab
        }}>
              {VALUE_TAB[group.duration]?.month}
            </Tabs.Tab>
          </div>)}
      </Tabs.List>
      <div className="text-center text-blackThree ">در هزینه و زمان خود با آی‌نو صرفه جویی کنید</div>
      {data.map((group, index) => <Tabs.Panel className={cs(WRAP_STYLE[group.color || 'blue'], 'flex flex-col gap-4 md:flex-row p-4 ')} key={VALUE_TAB[group.duration]?.month} value={String(index)}>
          {group.items.map(plan => <SubscriptionPlan {...plan} key={plan.id} blank />)}
        </Tabs.Panel>)}
    </Tabs>;
};
export default WelcomeSubscriptionTab;